module.exports = __webpack_public_path__ + "img/diaceutics-brand-gradients-08.0a8eb07f.png";